import React from "react";
import R14, { View } from "../../core";
import { STRIPE_KEY } from "../../constant/app.data.constant";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentElementComponent from "./PaymentElementComponent";
import { commonStyles } from "../../assets/css/commonStyle"; 

export default R14.connect(
  class PaymentCheckoutComponent extends React.Component {
    render() {
      let  clientSecret;
      const { bill } = this.props;
      if (!!bill) {
        clientSecret = !clientSecret ? (!!bill.clientSecret ? bill.clientSecret : clientSecret) : clientSecret;
        // delete bill.clientSecret;
        delete bill.customerId;
        delete bill.loadcustomerEphemeralKeySecret;
      }
      let stripePromise = loadStripe(STRIPE_KEY.publishableKey);
    
      const appearance = {
        theme: 'night',      
        variables: {
          colorPrimary: '#0570de',
          colorBackground: '#ffffff',
          colorText: '#30313d',
          colorDanger: '#df1b41',
          fontFamily: 'Work Sans',
          fontSizeBase:"15px",
          // spacingUnit: '2px',
          borderRadius: '4px',
          textTransform: "capitalize",
          boxShadow: '0 0px 0px 0 rgba(0, 0, 0, 0)'
          // See all possible variables below
        },
        rules:{
          '.Accordion': {
            // borderWidth: '0px',
            // boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)',
          },
          '.AccordionItem': {
            boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)',
            borderWidth:"1px",
            borderColor:"#e2e2e2",
            borderStyle:"solid",
            borderRadius: '5px',
          },
          '.Label':{
            fontFamily: 'Work Sans',
            fontSize:"14px",
            fontWeight: 400,
            textTransform: "capitalize",
            color:"#151b26",
            colorText:"#151b26"
          },
          '.Input':{
            fontFamily: 'Work Sans',
            fontSize:"13px",
            fontWeight: 400,
            borderRadius: '5px',
            boxShadow: '0 0px 0px 0 rgba(0, 0, 0, 0)',
            height:"30px",
            borderWidth:"1px",
            borderColor:"#e2e2e2",
            borderStyle:"solid",
            minHeight: "30px",
            padding:"6px"
          },
          '.Input:focus':{
            fontFamily: 'Work Sans',
            fontSizeBase:"13px",
            borderRadius: '5px',
            fontWeight: 400,
            boxShadow: '0 0px 0px 0 rgba(0, 0, 0, 0)',
            borderWidth:"2px",
            borderColor:"#397EA0",
            borderStyle:"solid",
          },
          '.Input--invalid': {
            boxShadow: '0 0px 0px 0 rgba(0, 0, 0, 0)',
          },
        }
      };
      return (
        <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.flexWrap, commonStyles.flexGrow0, commonStyles.alignItemsCenter, commonStyles.marginRight16]}>
          {!!clientSecret && !!stripePromise ?
           <Elements stripe={stripePromise} options={{ clientSecret, appearance }}>
            <PaymentElementComponent
              props={this.props}
              handleCheckout={this.props.handleCheckout}
              bill={bill}
            />
          </Elements>
            : 
             null
          }
        </View>
      )
    }
  }
);